import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();
const { projectCode } = PROJECT_CODE;

export async function assignSalesAgentToCoBroker(salesAgentId, coBrokerId) {
	let coBrokerRef = firebaseRef.ref(
		'/kavtek_coBrokers/' + projectCode + '/' + coBrokerId
	);

	coBrokerRef.update({
		assignedSalesAgent: salesAgentId ? salesAgentId : null,
	});
}

export async function deleteCoBroker(coBrokerId) {
	if (coBrokerId) {
		let coBrokerRef = firebaseRef.ref(
			'/kavtek_coBrokers/' + projectCode + '/' + coBrokerId
		);
		let coBrokerUserId;
		await coBrokerRef.once('value', (snapshot) => {
			coBrokerUserId = snapshot.val().userId;
		});

		let deleteCoBrokerAccount = firebase
			.functions()
			.httpsCallable('deleteCoBrokerAccount');
		await deleteCoBrokerAccount(coBrokerUserId);

		coBrokerRef.remove();
	}
}

export async function updateCoBroker(coBrokerId, coBroker) {
	let coBrokerRef = firebaseRef.ref(
		'/kavtek_coBrokers/' + projectCode + '/' + coBrokerId
	);

	coBrokerRef.update({
		salesAgency: coBroker?.salesAgency ? coBroker.salesAgency : '',
		email: coBroker?.email ? coBroker.email : '',
		phoneNumber: coBroker?.phoneNumber ? coBroker.phoneNumber : '',
		address: coBroker?.address ? coBroker.address : '',
		commissionPercentage: coBroker?.commissionPercentage
			? coBroker.commissionPercentage
			: 0,
		numberOfLotsAllowed: coBroker?.numberOfLotsAllowed
			? coBroker.numberOfLotsAllowed
			: 1,
		updatedAt: new Date().getTime(),
	});

	if (coBroker?.userId) {
		let userRef = firebaseRef.ref('/users/' + coBroker.userId);
		userRef.update({
			fullName: coBroker?.name ? coBroker.name : '',
		});
	}

	let assignedLotsOldValue = [];
	let lotsRef = firebaseRef.ref('/kavtek_lots/' + projectCode);
	lotsRef
		.orderByChild('assignedCoBroker')
		.equalTo(coBrokerId)
		.once('value', (snapshot) => {
			if (snapshot.val()) {
				let filteredLots = Object.values(snapshot.val())
					.filter((lot) => lot)
					.map((lot) => lot.lotId);
				assignedLotsOldValue = filteredLots;
			}
		});
	assignedLotsOldValue.forEach(async (lotId) => {
		if (!coBroker.assignedLots.includes(lotId.toString())) {
			let lotRef = firebaseRef.ref(
				'/kavtek_lots/' + projectCode + '/' + lotId
			);
			await lotRef.update({
				assignedCoBroker: null,
			});
		}
	});

	coBroker.assignedLots.forEach(async (lot) => {
		let lotRef = firebaseRef.ref('/kavtek_lots/' + projectCode + '/' + lot);
		await lotRef.update({
			assignedCoBroker: coBrokerId,
		});
	});
}
